import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as r, normalizeClass as l, normalizeStyle as n, createElementVNode as a } from "vue";
const c = o("arrow-up2"), p = /* @__PURE__ */ a("path", {
  d: "M623.406 815.479A129.722 129.722 0 1 1 487.068 594.95C691.9 468.083 896.73 341.993 1101.691 215.125a194.583 194.583 0 0 1 204.442 0l614.494 379.567a129.722 129.722 0 1 1-136.338 220.657l-580.506-358.292-580.377 358.422",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), i = [
  p
];
function m(e, _, d, f, u, w) {
  return s(), r("svg", {
    class: l(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2472 1024",
    role: "presentation"
  }, i, 6);
}
const v = /* @__PURE__ */ t(c, [["render", m]]);
export {
  v as default
};
